// Per-month price and savings in plan bullets are computed from the real prices,
// so stale numbers stored in the DB (e.g. "91 kr/mån") never reach the user.
export const fixPriceNumbers = (features, plan, plans) => {
  if (!Array.isArray(features)) return features;
  const toMonths = (p) => {
    const v = Number(p.duration_value || p.duration) || 0;
    if (/^year/.test(p.duration_type || p.durationType || '')) return v * 12;
    return v || Math.round((p.duration_days || 0) / 30);
  };
  const months = toMonths(plan);
  const monthly = plans.find((p) => toMonths(p) === 1 && Number(p.price) > 0);
  const price = Number(plan.price);
  if (!months || months <= 1 || !monthly || !price) {
    return features.map((f) => (typeof f === 'string' ? f.replace(/^24 اختبار تدريبي$/, '33 اختبار تدريبي') : f));
  }
  const perMonth = Math.round(price / months);
  const savePct = Math.round((1 - price / (Number(monthly.price) * months)) * 100);
  return features.map((f) => {
    if (typeof f !== 'string') return f;
    if (/[%٪]/.test(f)) return f.replace(/\d+(?=\s*[%٪])|(?<=[%٪]\s*)\d+/, String(savePct));
    if (/(kr|کرون|كرونة|كرون|SEK)\s*\//i.test(f)) return f.replace(/\d+/, String(perMonth));
    return f;
  });
};
